import { MutationTree } from "vuex";
import { LomsStateInterface } from "./state";
import { ILomListItem, ILomItem } from "src/modules/loms/models";

const mutation: MutationTree<LomsStateInterface> = {
  setLomsList(state, payload: ILomListItem[]) {
    state.loms = payload;
  },
  pushLomsList(state, payload: ILomListItem[]) {
    state.loms.push(...payload);
  },
  addLomsList(state, payload: ILomListItem) {
    state.loms.unshift(payload);
  },
  updateNameLomsListItem(state, payload: ILomListItem) {
    const index = state.loms.findIndex((lom) => lom.guid === payload.guid);
    state.loms[index].name = payload.name;
  },
  incrementTotalCont(state, payload: ILomListItem) {
    state.totalCount = state.totalCount + 1;
  },
  setTotalCount(state, payload: number) {
    state.totalCount = payload;
  },
  setLomDetail(state, payload: ILomItem | undefined) {
    state.lomDetail = payload;
  },
  deleteChannelFromLom(state, payload: string[]) {
    if (state.lomDetail) {
      state.lomDetail.channels =
        state.lomDetail?.channels?.filter(
          (channel) => !payload.includes(channel.guid),
        ) || null;
    }
  },
  deleteEntityFromLom(state, payload: string[]) {
    if (state.lomDetail) {
      state.lomDetail.entities =
        state.lomDetail?.entities?.filter(
          (entity) => !payload.includes(entity.guid),
        ) || null;
    }
  },
  deleteLomFromList(state, guid: string) {
    state.loms = state.loms.filter((lom) => lom.guid !== guid);
    state.totalCount = state.totalCount - 1;
  },
};

export default mutation;
